<template>
  <div
    class="cpt-member-manage-filter-container"
    :class="`type-${type}`"
  >
    <Radio
      v-for="(item, index) in options"
      :key="index"
      :label="item.label"
      :active="!usingRange && isEqual(value, item.value)"
      @click.native.stop="handleChange(item)"
    />
    <div class="divider"></div>
    <Radio
      label="自定义范围"
      :active="usingRange"
      @click.native.stop="handleUseRange()"
    />
    <div
      class="custom-range-value"
      v-if="usingRange"
      >{{ customFormatter(ranges[0], ranges[1])}}</div
    >
  </div>
</template>

<script>
import Radio from '_com/menu/Radio';
import {
  ENTER_TIME_OPTIONS,
  LEVEL_OPTIONS,
} from '_lib/constants/member-manage';

export default {
  name: 'MemberManageFilter',
  components: {
    Radio,
  },
  props: {
    value: {},
    type: {
      type: String,
      default: 'level',
    },
    ranges: {
      type: Array,
      default: () => [],
    },
    customFormatter: {
      type: Function,
      default: (value1, value2) => `${value1} - ${value2}`,
    }
  },
  data() {
    return {
      usingRange: false,
    };
  },
  computed: {
    options() {
      if (this.type === 'level') {
        return LEVEL_OPTIONS;
      } else {
        return ENTER_TIME_OPTIONS;
      }
    },
  },
  methods: {
    handleChange(item) {
      this.$emit('switchPanel', false);
      this.usingRange = false;
      this.handleUpdateValue(item);
      this.handleClearCustomRange()
    },
    handleUseRange() {
      if (!this.usingRange) {
        this.usingRange = true;
        this.$emit('switchPanel', true);
      } else {
        this.usingRange = false
        this.$emit('switchPanel', false);
        this.handleUpdateValue({ value: ['0', '0'] });
        this.handleClearCustomRange()
      }
    },
    handleUpdateValue(item) {
      if(this.isEqual(this.value, item.value)){
        this.$emit('input', ['0', '0']);
        return
      }
      this.$emit('input', item.value);
    },
    handleClearCustomRange(){
      this.$emit('clearCustomRange')
    },
    isEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<style lang="scss">
.cpt-member-manage-filter-container {
  .type-level {
    height: 217px;
  }
  .type-enter-time {
  }
  position: relative;
  .cpt-radio-row {
    cursor: pointer;
    display: flex;
    padding: 6px 8px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    .text p {
      text-align: start;
    }
    .radio {
      border-color: $d-op-2;
    }
    &.active {
      .text p {
        color: $d-tx-1;
        font-weight: 700;
      }
    }
    &:hover {
      border-radius: 5px;
      background: $d-bd-fl !important;
      .text p {
        color: $ct-wh-0;
      }
      .radio {
        border-color: $ct-wh-0 !important;
        &::after {
          background: $ct-wh-0 !important;
        } 
      }
    }
  }
  > .divider {
    height: 1px;
    margin: 4px 8px;
    gap: 10px;
    align-self: stretch;
    background: $d-op-2;
  }
  .custom-range-value {
    width: 100%;
    padding: 0 8px;
    text-align: start;
  }
}
</style>
